export default "__VITE_ASSET__B9esgS52__"